import treeStore from "../store/treeStore";
import pathStore from "../store/pathStore";
import tableStore from "../store/tableStore";
import uuidv1 from 'uuid/v1';

import { setTree } from "../action/treeAction";
import { setRelationships } from '../action/pathAction';
import { createNewTable, setTable } from "../action/tableActions";
import userStore from "../store/userStore";
import { addNotification } from '../action/notificationAction';
import axios from 'axios';
import { Config } from '../config';
import { setStage } from '../action/userActions';
import StageManager from "./stageManager";
import getHeaders from './header';

const urlStarter = Config[Config.env].functionappurl;

// const urlStarter = "http://localhost:7071/api/";


/**
 * sends the table and nodes to the API so they can be saved
 * @param completed left empty if the tree isn't completed yet - this pushes stage further
 */
export function publishData(completed) {
    return new Promise(async (resolve, reject) => {
        let url = urlStarter + "api/trees?saveTree=true&userId="
            + userStore.user.id + (completed ? "&treeCompleted=true" : "");
        if (tableStore.table.tableName === "") {
            addNotification({ status: "fail", message: "You must name your table" });
            return;
        }
        if (tableStore.table.id === "") {
            tableStore.table.id = uuidv1();
        }
        if (tableStore.table.user === "") {
            tableStore.table.user = userStore.user.id;
        }
        const stageManager = new StageManager();
        let feedbackName = completed ? stageManager.getStageByIndex(userStore.user.stage).name : undefined;
        let obj = {
            // treeName: treeStore.treeName,
            table: tableStore.table,
            nodes: treeStore.tree,
            relationships: pathStore.relationship,
            deleteTree: treeStore.deletedTree,
            deleteRel: pathStore.deletedRelationship,
            feedbackName: feedbackName
        };
        const headers = await getHeaders();
        localStorage.removeItem('tree-nodes');
        axios.post(url, obj, { headers: headers }).then((response) => {
            addNotification({ status: "saving", message: `Successfully saved` });
            if (response.data.stage) {
                setStage(response.data.stage);
            }
            resolve();
        }).catch(() => {
            addNotification({ status: "fail", message: "Could not save, please try again" });
        });
    });
}
export const saveThemes = async (companyId, themeName, themeJSON) => {
    const headers = await getHeaders();
    let url = urlStarter + `api/dohertyPortal?saveTheme=${companyId}&userId=` + userStore.user.id;;
    const res = await axios.post(url, { themeName, themeJSON }, { headers: headers });
    return res.data;
};
/**
 * retrieves the users trees and saves them to the store of available tables
 * @todo user lookups
 * @todo dead atm doesn't do anything
 */
export function getSavedTrees() {
    return new Promise(async (resolve, reject) => {
        //this would be for that user id
        const headers = await getHeaders();

        let userId = userStore.user.company;
        let url = urlStarter + `api/trees?getTables=${userId}`;
        axios.get(url, { headers: headers }).then((response) => {
            resolve(response.data.message);
        }).catch((e) => {
            reject(e);
        });
    });
}
/**
 * retrieves the trees that are ready to be published
 */
export function getPublishedTrees() {
    return new Promise(async (resolve, reject) => {
        let url = urlStarter + "api/dohertyPortal?getPublishTables=true&userId=" + userStore.user.id;
        const headers = await getHeaders();

        axios.get(url, { headers: headers }).then((response) => {
            resolve(response.data.message);
        }).catch((e) => {
            reject(e);
        });
    });
}
/**
 * deletes a table from the database by passing through the Id
 * @param {string} tableId the table id 
 */
export async function deleteTable(tableId) {
    let url = urlStarter + `api/trees?deleteTable=${tableId}`;
    const headers = await getHeaders();

    axios.delete(url, { headers: headers }).then((response) => {
        addNotification({ status: "success", message: "Sucessfully deleted tree" });
        newTree();
    }).catch(() => {
        addNotification({ status: "fail", message: "Could not delete tree" });

    });

}
//ill export this data to the stores

/**
 * retrieves the nodes and relationships from the API then sets them up in the store
 * @param {string | undefined} companyId the companies id of the tree you want if left undefined, it gets the users tree
 */
export async function getTreeFromDb(companyId) {
    if (userStore.user.company) {
        let url = urlStarter + `api/trees?getTree=${companyId ? companyId : userStore.user.company}&userId=${userStore.user.id}`;
        const headers = await getHeaders();

        sessionStorage.removeItem("tree-nodes");

        axios.get(url, { headers: headers }).then((response) => {
            let treeNodes = response.data.message[0],
                treeRel = response.data.message[1],
                table = response.data.message[2];
            // console.log(response);
            sessionStorage.setItem("tree-nodes", JSON.stringify(treeNodes));

            table.publish = false;
            setTree({ nodes: treeNodes });
            setRelationships({ relationships: treeRel });
            setTable({ table: table });
            addNotification({ status: "success", message: "Sucessfully retrieved tree" });
        }).catch((e) => {
            addNotification({ status: "fail", message: "Could not get tree" });
        });
    }

}

/**
 * this triggers the create site flow
 * @param {string} treeId the tree id you want to publish
 */
export async function publishSite(treeId) {
    let url = urlStarter + 'api/dohertyPortal?publishTree=true&userId=' + userStore.user.id;
    // let url = 'http://localhost:7073/api/orchestrators/CreateSPSite';

    let payload = {
        treeId: treeId
    };
    console.log(payload);
    const headers = await getHeaders();

    axios.post(url, payload, { headers: headers }).then(() => {
        addNotification({ status: "success", message: "Sucessfully started building site" });

    }).catch(() => {
        addNotification({ status: "fail", message: "Could not start site builder" });
    });
}
/**Gets the publish states
 * Uses the TreeIDto get the state 
 */
export const getPublishStates = async (treeId) => {
    let url = urlStarter + 'api/dohertyPortal?getState=' + treeId + '&userId=' + userStore.user.id;
    const headers = await getHeaders();
    const response = await axios.get(url, { headers });
    return response.data;
};
/**
 * saves the tree and associated data into local storage
 */
export function locallyPersistData() {
    let obj = {
        table: tableStore.table,
        nodes: treeStore.tree,
        relationships: pathStore.relationship,
        deleteTree: treeStore.deletedTree,
        deleteRel: pathStore.deletedRelationship
    };
    let parsed = JSON.stringify(obj);
    let savedData = localStorage.getItem('tree-nodes');
    if (savedData !== obj || savedData === null) {
        localStorage.setItem('tree-nodes', parsed);
    } else {
        localStorage.removeItem('tree-nodes').then(() => {
            localStorage.setItem('tree-nodes', parsed);
        });
    }
}
/**
 * loads the tree and associated data from local storage
 */
export function loadLocalData() {
    let savedData = localStorage.getItem('tree-nodes');
    if (savedData === null) {
        return;
    }
    let parse = JSON.parse(savedData);
    setTree({ nodes: parse.nodes, deleteTree: parse.deleteRel });
    setRelationships({ relationships: parse.relationships, deeteRel: parse.deleteRel });
    setTable({ table: parse.table });

}


/**
 * creates a new tree by resetting all the stores
 * @todo add some validation on if a this is saved or something
 */
export function newTree() {
    setTree({ treeName: {}, nodes: {}, deleteTree: [] });
    setRelationships({ relationships: {}, deleteRel: [] });
    createNewTable("");
}



// WEBPACK FOOTER //
// ./src/services/publishData.js